import { useState, useEffect, FunctionComponent, } from 'react';
import { Button, Switch, Tabs, Dialog } from '../../tailwindcomponents';
import { Typography, Input } from '../../tailwindcomponents';
import { Dictionary } from '../../components';
import CertificatesApi from './../../api/certificates';
import { CertificateAircraftCategory, CertificateRating } from '../../types/certificates';
import { useSelector } from 'react-redux';
import { RootState } from '../../reducer';

type CertificateProps = {
  setLoading: Function
}

const EditProperties: FunctionComponent<CertificateProps> = ({ setLoading }) => {
  const [aircraftTypes, setAircraftTypes] = useState(Array<CertificateAircraftCategory>());
  const [ratingTypes, setRatingTypes] = useState(Array<CertificateRating>());
  const [newPropertyInput, setNewPropertyInput] = useState('');
  const store = useSelector((state: RootState) => state);
  const currentUser = store.user.me;
  const [tabValue, setTabValue] = useState<number>(0);
  const [showActive, setShowActive] = useState(true);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [deleteReason, setDeleteReason] = useState('');
  const [selectedAircraft, setSelectedAircraft] = useState<CertificateAircraftCategory | undefined>(undefined);
  const [selectedRating, setSelectedRating] = useState<CertificateRating | undefined>(undefined);

  useEffect(() => {
    refresh('rating');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const refresh = (dictionaryType: string) => {
    setLoading(true);
    if (dictionaryType === 'aircraft') {
      CertificatesApi.GetAllCertififcateAircraftCategories().then(res => {
        setAircraftTypes(res.data);

      })
    }
    if (dictionaryType === 'rating') {
      setLoading(true);
      CertificatesApi.GetAllCertificationRatings().then(res => {
        setRatingTypes(res.data);
        setLoading(false);
      })
    }
  }

  const onReasonEdit = (value: string) => {
    setDeleteReason(value);
  }

  const addProperty = (newProperty: string) => {
    let propertyToAdd;
    if (tabValue === 0) {
      propertyToAdd = { rating: newProperty, created_by_employee_id: currentUser.user_id }
      CertificatesApi.CreateNewCertificateRating(propertyToAdd).then(res => {
        refresh('rating');
        setNewPropertyInput('');
      })
    }
    if (tabValue === 1) {
      propertyToAdd = { aircraft_category: newProperty, created_by_employee_id: currentUser.user_id };
      CertificatesApi.CreateNewAircraftCategory(propertyToAdd).then(res => {
        refresh('aircraft');
        setNewPropertyInput('');
      });
    }
  }

  const deleteRating = (rating: CertificateRating) => {
    setSelectedRating(rating);
    setDeleteDialog(true);
  }

  const deleteAircraftCategory = (category: CertificateAircraftCategory) => {
    setSelectedAircraft(category);
    setDeleteDialog(true);
  }

  const confirmDelete = () => {
    if (selectedRating !== undefined) {
      selectedRating.reason = deleteReason;
      CertificatesApi.RemoveCertificateRatings(selectedRating).then(res => {
        setSelectedRating(undefined);
        refresh('rating');
      })
    }
    if (selectedAircraft !== undefined) {
      selectedAircraft.reason = deleteReason;
      CertificatesApi.RemoveCertificateAircraftCategoryById(selectedAircraft).then(res => {
        setSelectedAircraft(undefined);
        refresh('aircraft');
      })
    }
    setDeleteDialog(false);
    setDeleteReason('');
  }

  const onChangeTabValue = (tabValue: number) => {
    if (tabValue === 0) {
      refresh('rating');
    }
    if (tabValue === 1) {
      refresh('aircraft');
    }
    setTabValue(tabValue);
  }

  return (
    <div>
      <div className="w-full">
        <Typography align='center' variant='h2' text={tabValue === 0 ? "Add new Rating Property" : "Add new Aircraft Property"}></Typography>
      </div>
      <div className="w-full flex flex-wrap" >
        <div className="w-1/12 flex flex-wrap">
        </div>
        <div className="w-1/2 flex flex-wrap">
          <div className="w-full flex flex-wrap">
            <div className="w-full lg:w-7/12 xl:w-1/2">
              <Tabs
                tabNames={["Ratings", "Aircrafts"]}
                onChangeTabValue={(tabValue: number) => onChangeTabValue(tabValue)}
                tabValue={tabValue}
              />
            </div>
            <div className="w-1/6 lg:w-1/12">
              <Typography text="Active" variant="subtitle2" color="textPrimary" margin={[1, 0, 0, 0]} />
            </div>
            <div className="w-1/6 lg:w-1/12">
              <Switch
                checked={!showActive}
                onChange={() => setShowActive(!showActive)}
                color="secondary"
                name="checkedB"
              />
            </div>
            <div className="w-1/6 lg:w-1/12">
              <Typography text="Deleted" variant="subtitle2" color="textPrimary" margin={[1, 0, 0, 0]} />
            </div>
          </div>
          {tabValue === 0 &&
            <div className="w-5/6">
              {
                ratingTypes.filter(rating => rating.visible === showActive).map(row => (
                  <Dictionary name={row.rating} object={row} deleted={showActive === true ? false : true} description={showActive === true ? '' : row.reason} id={row.id} deleteProperty={(row: CertificateRating) => deleteRating(row)}></Dictionary>
                ))
              }
            </div>
          }
          {tabValue === 1 &&
            <div className="w-5/6">
              {
                aircraftTypes.filter(type => type.visible === showActive).map(row => (
                  <Dictionary name={row.aircraft_category} object={row} deleted={showActive === true ? false : true} description={showActive === true ? '' : row.reason} id={row.id} deleteProperty={(row: CertificateAircraftCategory) => deleteAircraftCategory(row)}></Dictionary>
                ))
              }
            </div>
          }
        </div>
        <Dialog
          visible={deleteDialog}
          max_width={"md"} title={"Are you sure you want to delete this?"}
          context={
            <div>
              <div className="flex justify-center w-full m-2 p-2">
                <Input
                  label_text={"Type a reason"} value={deleteReason} help_text=""
                  onTextChange={(value: string) => onReasonEdit(value)} type="text" width={50} multiline={false} />
              </div>
              <div className="flex justify-center m-2 p-2">
                <div className="p-2" >
                  <Button variant="contained" color="primary" onClick={() => confirmDelete()}>Confirm delete</Button>
                </div>
                <div className="p-2">
                  <Button variant="contained" color="secondary" onClick={() => setDeleteDialog(false)}>Cancel</Button>
                </div>
              </div>
            </div>
          }
          onClose={(status: any) => setDeleteDialog(false)}
          strict={false}
          show_options={false}
        />
        <div className="w-5/12">
          <div className="w-full">
            <br />
            <Input
              multiline={false}
              label_text="New Property"
              help_text=""
              type="text"
              value={newPropertyInput}
              width={50}
              onTextChange={(value: string) => setNewPropertyInput(value)}
            />
          </div>
          <br />
          <Button variant="contained" color="primary" className="bg-accent text-[color:var(--ds-accent-fg)] text-sm" onClick={() => addProperty(newPropertyInput)} >
            Add Property
          </Button>
        </div>
      </div>
    </div>
  );
};
export default EditProperties;
